import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 创建订单
export function createOrder(data, params) {
  return request({
    url: URL.railwayExport.createOrder,
    method: 'post',
    data,
    params
  })
}

// 修改订单
export function updateOrder(data, params) {
  return request({
    url: URL.railwayExport.updateOrder,
    method: 'post',
    data,
    params
  })
}

// 删除订单
export function deleteOrder(data) {
  return request({
    url: URL.railwayExport.deleteOrder,
    method: 'delete',
    data
  })
}

// 铁路出口箱子订单高级查询
export function railwayContainerOrderAdvancedQuery(data) {
  return request({
    url: URL.railwayExport.railwayContainerOrderAdvancedQuery,
    method: 'post',
    data
  })
}

// 根据指定订单列表查询可用箱子
export function queryAvailableContainerData(params) {
  return request({
    url: URL.railwayExport.queryAvailableContainerData,
    method: 'get',
    params
  })
}

// 箱管订单列表
export function queryContainerDetail(params) {
  return request({
    url: URL.railwayExport.queryContainerDetail,
    method: 'get',
    params
  })
}

// 创建卖箱订单并修改可用箱状态
export function createOrderForSell(data, params) {
  return request({
    url: URL.railwayExport.createOrderForSell,
    method: 'post',
    data,
    params
  })
}
